import React, { useEffect, useState } from 'react'
import { Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Button, Flex, Grid, GridItem, Popover, PopoverBody, PopoverContent, PopoverTrigger, Text, useDisclosure } from '@chakra-ui/react'
import MyDiv from './regularisationDetail.style'
import * as routesNames from '../../../constants/routes'
import { CalendarIcon } from '@chakra-ui/icons'
import Calendar from 'react-calendar'
import RegularisationProfile from '../components/RegularisationProfile'
import RegularisationCalendar from '../components/RegularisationCalendar'
import { useLocation } from 'react-router-dom'
import { useFetch } from '../../../hooks/useFetch'
import { CustomToast } from '../../../components'

interface AttendanceRecord {
    id: number;
    employeeId: number;
    startTime: string;
    endTime: string | null;
    status: number;
    actualHours: number;
}

interface AttendanceSummary {
    averageHoursPerDay: number;
    leaveOrOtherPercent: number;
    presencePercent: number;
    records: AttendanceRecord[];
}


const RegularisationDetail = () => {
    const location = useLocation();
    // const employeeId: number = location.state?.employeeId;
    //   const [attendanceData, setAttendanceData] = useState<AttendanceSummary | null>(null);
    // const [selectedDate, setSelectedDate] = useState(new Date());
    const employeeId: number = location.state?.employeeId;
    const regularisationDate = location.state?.date;
    const [attendanceData, setAttendanceData] = useState<AttendanceSummary | null>(null);
    const [selectedDate, setSelectedDate] = useState<Date>( regularisationDate ? new Date(regularisationDate) : new Date() );
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { addToast } = CustomToast();
    const { fetchApi } = useFetch(addToast);
    const formatMonthYear = (date: Date) => date.toLocaleString('default', { month: 'long', year: 'numeric' });


    const LoadAttendanceData = async () => {
        try {
            const params = new URLSearchParams({
                employeeId: employeeId ? employeeId.toString() : "",  // 👈 pass employeeId
                month: (selectedDate.getMonth() + 1).toString(),
                year: selectedDate.getFullYear().toString(),
            });
            const response = await fetchApi(
                `Hrlense_Attendance/GetEmployeeMonthlyAttendanceByEmployee?${params}`,
                "GET"
            );
            if (response) {
                if (response.records.length === 0) {
                    addToast({
                        message: "No attendance data found for the selected month.",
                        status: "warning",
                    });
                }
                setAttendanceData(response);
            }
        } catch (error) {
            console.error("Error fetching attendance data:", error);
        }
    };

    useEffect(() => {
        if (employeeId) {
            LoadAttendanceData();
        }
    }, [selectedDate]);



    return (
        <MyDiv>
            <Box>
                <Flex className="flex_header" >
                    <Breadcrumb spacing='5px' className="font_poppins text_md text_medium" separator=">>">
                        <BreadcrumbItem>
                            <BreadcrumbLink className="font_poppins text_md text_medium" color="gray.500" href={routesNames.REGULARISATION}>Regularisation</BreadcrumbLink>
                        </BreadcrumbItem>
                        <BreadcrumbItem isCurrentPage>
                            <BreadcrumbLink className="font_poppins text_md text_medium" href="#">Employee Attendance</BreadcrumbLink>
                        </BreadcrumbItem>
                    </Breadcrumb>
                    <Flex gap={2}>
                        <Popover isOpen={isOpen} onOpen={onOpen} onClose={onClose} placement="bottom-end">
                            <PopoverTrigger>
                                <Button leftIcon={<CalendarIcon />} padding={3} variant="outline" >
                                    <Text className="font-poppins text_sm text_regular">
                                        {formatMonthYear(selectedDate)}
                                    </Text>
                                </Button>
                            </PopoverTrigger>
                            <PopoverContent w="auto">
                                <PopoverBody p={2} display="flex" justifyContent="center">
                                    <Calendar
                                        value={selectedDate}
                                        onChange={(value) => {
                                            if (value instanceof Date) {
                                                setSelectedDate(value);
                                                onClose();
                                            }
                                        }}
                                        view="year"
                                        maxDetail="year"
                                        maxDate={new Date()} // This prevents selecting future dates
                                    />
                                </PopoverBody>
                            </PopoverContent>
                        </Popover>


                    </Flex>
                </Flex>
                <Grid className='grid_container'>
                    <GridItem colSpan={4} h="100vh" overflow="hidden">
                        <Box position="sticky" top="0" h="100vh" overflowY="auto" className='tab-list-container' mt={4}>
                            <RegularisationProfile employeeId={employeeId} />
                        </Box>
                    </GridItem>
                    <GridItem colSpan={8} pl={4} >
                        <RegularisationCalendar attendanceData={attendanceData} selectedDate={selectedDate}
                        // pass props for highlightDate 
                          highlightDate={regularisationDate ? new Date(regularisationDate) : null} />
                    </GridItem>
                </Grid>

            </Box>
        </MyDiv>
    )
}

export default RegularisationDetail;
